export const ASSET_GET_ID = 'ASSET_GET_ID';
export const ASSET_CREATE = 'ASSET_CREATE';
export const ASSETS_GET_MY = 'ASSETS_GET_MY';
export const CLASSIFICATION_CAV = 'CLASSIFICATION_CAV';
export const ANNOUNCEMENT_GET_ID = 'ANNOUNCEMENT_GET_ID';
export const ANNOUNCEMENTS_GET_MY = 'ANNOUNCEMENTS_GET_MY';
export const GET_BANK_ACCOUNTS_LIST = 'GET_BANK_ACCOUNTS_LIST';
export const EXECUTION_GET_ID = 'EXECUTION_GET_ID'
export const EXECUTIONS_GET_MY = 'EXECUTIONS_GET_MY';